export default {
  myFiles: [],
  companyFiles: [],
  myFilesPage: 1,
  companyFilesPage: 1,

  loadingMyFiles: false,
  loadMyFilesSuccess: false,
  loadMyFilesFailed: false,
  loadMyFilesError: false,

  loadingCompanyFiles: false,
  loadCompanyFilesFailed: false,
  loadCompanyFilesError: false,
};



// WEBPACK FOOTER //
// ./src/store/modules/filebox/state.js